import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconSubscriptionTick2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSubscriptionTick2"><G ClipPath="url(#clip0_9186_28824)"><Path d="M12 1.5L9 4.5H4.5V9L1.5 12L4.5 15V19.5H9L12 22.5L15 19.5H19.5V15L22.5 12L19.5 9V4.5H15L12 1.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.25 13.225L10.7955 15.5L15.25 9" stroke="currentColor" strokeLinecap="square"/></G><Defs><ClipPath id="clip0_9186_28824"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconSubscriptionTick2;
